import {
  goalkeeperSeasonTableMetricGroups,
  goalkeeperSeasonTableMetrics,
  outfieldSeasonTableMetricGroups,
  outfieldSeasonTableMetrics,
  playerMetricMap,
  skillcornerStats
} from '../static/playerMetrics';
import { RoleConfig } from '../types/tenant';


export const getRoundedIndexValue = (index: number | undefined | null): number => {
  if (index === undefined || index === null) return 0;
  return Math.round(index * 10) / 10;
};


export const getNormalizedMetricName = (metric: string) => {
  if (metric === 'skill_rating' || metric === 'physical_rating' || !playerMetricMap[metric]) return metric;
  if (metric.endsWith('_normalized')) return metric;
  return metric + '_normalized';
};


export const getSortByMetricName = (metric: string | undefined, sortByActualValues: boolean | undefined) => {
  if (!metric || !sortByActualValues) return metric;
  if (metric === 'skill_rating') return metric;
  if (outfieldSeasonTableMetricGroups.obv.includes(metric.replace(/_normalized$/, ''))) return metric;
  return metric.replace(/_normalized$/, '');
};


export const getRoleConfigMetricGroups = (positionGroup: string, hasSkillcorner?: boolean) => {
  return positionGroup === 'GK'
    ? goalkeeperSeasonTableMetricGroups
    : hasSkillcorner
      ? { ...outfieldSeasonTableMetricGroups, 'skillcorner': skillcornerStats }
      : outfieldSeasonTableMetricGroups;
};


export const getRoleConfigMetrics = (positionGroup: string, hasSkillcorner?: boolean) => {
  return positionGroup === 'GK'
    ? goalkeeperSeasonTableMetrics
    : hasSkillcorner
      ? [...outfieldSeasonTableMetrics, ...skillcornerStats]
      : outfieldSeasonTableMetrics;
};


export const roleConfigIsBeingComputed = (roleConfig: RoleConfig | undefined): boolean => {
  return roleConfig !== undefined && (
    !roleConfig.weightsLastUpdated ||
    !roleConfig.dataLastUpdated ||
    roleConfig.dataLastUpdated < roleConfig.weightsLastUpdated
  );
};


export const isSkillcornerMetric = (metric: string): boolean => {
  return playerMetricMap[metric]?.isSkillcornerMetric ?? false;
};


export const isLimitedMetric = (metric: string): boolean => {
  return (playerMetricMap[metric]?.isLimitedMetric ?? false) || isSkillcornerMetric(metric);
};


export const isLimitedRoleConfig = (roleConfig: RoleConfig): boolean => {
  return Object.keys(roleConfig.weights).some(metric => isLimitedMetric(metric));
};


export const isPhysicalRoleConfig = (roleConfig: RoleConfig): boolean => {
  return Object.keys(roleConfig.weights).some(metric => isSkillcornerMetric(metric));
};
